import { render, staticRenderFns } from "./PodsetnikVozilaDialog.vue?vue&type=template&id=421e08c6&scoped=true&"
import script from "./PodsetnikVozilaDialog.vue?vue&type=script&lang=ts&"
export * from "./PodsetnikVozilaDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PodsetnikVozilaDialog.vue?vue&type=style&index=0&id=421e08c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421e08c6",
  null
  
)

export default component.exports